import React, { ReactElement } from "react";
import styles from "./fabButton.module.scss";

export const FabButton = (props: {
  href: string;
  image?: string;
  target: string;
  onClick?: () => void;
}): ReactElement => {
  return (
    <div className={styles.position}>
      <a href={props.href} target={props.target} onClick={props.onClick}>
        <img src={props.image} alt="" />
      </a>
    </div>
  );
};
